import {store} from '../store/store.js';

export let AdobeAnalyticsByURL = {
  loadIfConfigured() {
    if (!this.isEnabled()) {
      return Promise.resolve();
    }
    this.downloadScript(store.state.config.adobeTrackingScriptUrl).then(() => {
      this.setUp();
    });
  },
  isEnabled() {
    return store.getters.isAdobeAnalyticsByURLEnabled;
  },
  downloadScript(scriptUrl) {
    return new Promise((resolve, reject) => {
      var script;
      script = window.document.createElement('script');
      script.type = 'text/javascript';
      script.src = scriptUrl;
      script.onload = script.onreadystatechange = () => {
        resolve();
      };
      script.onerror = (error) => {
        reject(error);
      }
      window.document.head.appendChild(script);
    });
  },
  setUp() {
    (function () {
      if (typeof window.CustomEvent === 'function') return false;
      function CustomEvent (event, params) {
        console.log('Using custom code for event');
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
      }
      CustomEvent.prototype = window.Event.prototype;
      window.CustomEvent = CustomEvent;
    })();
  },
  registerPlayer(playerInstance) {
    if (this.isEnabled()) {
      var event = new CustomEvent('jwplayerready', {detail: {'jwplayer': playerInstance}});
      window.dispatchEvent(event);
    }
  }
}
